// This Component is used as 'PAGE NOT FOUND' page. We use this Page/Component when Url link is Invalid.
import React, {useEffect, useState} from "react";
import './Common.css'

export default (props) => {
    const [PageDetails, setPageDetails] = useState({
        ImageUrl: `${process.env.PUBLIC_URL + "/Images/PageNotFound.gif"}`, //  Default Image for this Page.
        Message: 'The link you entered may be broken, or the page may have been removed.' //  Default Message for this Page.
    })
    // We can change the image of this page as well as Message of this page by passing ImageUrl and Message props.
    // Like :- <PageNotFound /> for default PageNotFound Page
    // <PageNotFound ImageUrl='IMAGE-URL' Message='Page not found'/> for Customize PageNotFound Page.
    useEffect(() => {
        if (props.ImageUrl !== undefined) {
            setPageDetails({
                ...PageDetails,
                ImageUrl: props.ImageUrl,
            });
        }
        if (props.Message !== undefined) {
            setPageDetails({
                ...PageDetails,
                Message: props.Message,
            });
        }
    }, [])
    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100 blue-background-color">
            <div className="row">
                <div className="col d-flex justify-content-center align-items-center">
                    <img src={PageDetails.ImageUrl} width='200' alt="Page Not Found.."/>
                    <div className='text-monospace'>
                        <h2>Sorry, this page isn`t available.</h2>
                        <div className='row w-75'>
                            <div className='col text-center'>
                                <b>{PageDetails.Message}</b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}